import inventoryText from "../inventoryI18n.js";
import React, { useState, useEffect, useContext } from "react";
import { API_URL } from "../../components/api";
import "bootstrap/dist/css/bootstrap.css";
import "./ProductEdit.css";
import Axios from "axios";
import Select from "react-select";
import AuthContext from "../../context/AuthContext";

function EditProduct(props) {
  function refreshPage() {
    window.location.reload(false);
  }

  const [message, setMessage] = useState(null);

  let { user } = useContext(AuthContext);
  let authTokens = JSON.parse(localStorage.getItem("authTokens"));
  const [name, setname] = useState("");
  const [group, setGroup] = useState("");

  const [description, setdescription] = useState("");
  const [code, setcode] = useState("");
  const [barcode, setbarcode] = useState("");
  const [category, setcategory] = useState("");
  const [cost, setcost] = useState("");
  const [price, setprice] = useState("");
  const [retail, setretail] = useState("");
  const [cat, setcat] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [supplier, setSupplier] = useState(
    props.supplier_id || null
  );
  const [isActive, setIsActive] = useState(
    props.is_active !== 0 && props.is_active !== false
  );

  useEffect(() => {
    let isMounted = true;
    const getcategories = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/inventory/products/categories/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
              "Content-Type": "application/json",
            },
            params: {
              username: user.username,
            },
          }
        );

        if (response.status === 200 && isMounted) {
          setcat(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    const getSuppliers = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/inventory/suppliers/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
              "Content-Type": "application/json",
            },
            params: {
              username: user.username,
            },
          }
        );

        if (response.status === 200 && isMounted) {
          setSuppliers(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    const fetchGroups = async () => {
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));
        const response = await Axios.get(`${API_URL}/administration/groups/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
          },
        });

        if (response.status === 200) {
          setGroup(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchGroups();
    getcategories();
    getSuppliers();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    setSupplier(props.supplier_id || null);
  }, [props.supplier_id]);

  const options = cat.map((item) => {
    return {
      label: item.category_name,
      value: item.category_id,
    };
  });

  const supplierOptions = suppliers.map((item) => {
    return {
      label: item.company_name,
      value: item.supplier_id,
    };
  });

  const selectedSupplier =
    supplierOptions.find(
      (option) =>
        String(option.value) === String(supplier)
    ) || null;

  const showMessage = (message, type = "success") => {
    setMessage({ text: message, type });

    // Close the modal after 3 seconds
    setTimeout(() => {
      refreshPage();
    }, 1200);

    // Clear the message after 5 seconds
    setTimeout(() => {
      setMessage(null);
    }, 1000);
  };

  let handleSubmit = async (e) => {
    e.preventDefault();
    Axios.post(
      `${API_URL}/inventory/products/`,
      {
        Action: "Put",
        product: props.product_id,
        name: name,
        description: description,
        code: code,
        barcode: barcode,
        category: category,
        cost: cost,
        price: price,
        retail: retail,
        supplier: supplier,
        ...(group === "yes" ? { is_active: isActive } : {}),
        userdealer: user.username,
      },
      {
        headers: {
          Authorization: `Bearer ${authTokens.access}`,
        },
      }
    )
      .then((response) => {
        console.log(response);
        showMessage("Edit successful!", "success"); // Show the success message
      })
      .catch((error) => {
        console.log(error);
        showMessage("Edit failed!", "danger"); // Show the error message
      });
  };

  return (
    <div className="testi">
      <div className="mod">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{inventoryText("inventory.Name")}:<input
                className="form-control"
                type="text"
                placeholder={props.name}
                value={name}
                onChange={(e) => setname(e.target.value)}
              />
            </label>

            <label>{inventoryText("inventory.Description")}:<input
                className="form-control"
                type="text"
                placeholder={props.description}
                value={description}
                onChange={(e) => setdescription(e.target.value)}
              />
            </label>
          </div>
          <div className="form-group">
            <label>{inventoryText("inventory.Code")}:<input
                className="form-control"
                type="text"
                placeholder={props.code}
                value={code}
                onChange={(e) => setcode(e.target.value)}
              />
            </label>
            <label>
              Barcode:
              <input
                className="form-control"
                type="text"
                placeholder={props.barcode}
                value={barcode}
                onChange={(e) => setbarcode(e.target.value)}
              />
            </label>
          </div>
          <div className="form-group">
            <label>
              Category:
              <Select
                className="search-line"
                classNamePrefix="product-edit-select"
                placeholder={props.category_name}
                options={options}
                onChange={(opt) => setcategory(opt.value)}
              />
            </label>

            <label>
              Supplier:
              <Select
                className="search-line"
                classNamePrefix="product-edit-select"
                placeholder={inventoryText("inventory.SelectSupplier")}
                options={supplierOptions}
                value={selectedSupplier}
                isClearable
                onChange={(opt) =>
                  setSupplier(opt ? opt.value : null)
                }
              />
            </label>
          </div>
          <label>{inventoryText("inventory.Cost")}:<input
              className="form-control"
              type="number"
              step="0.0001"
              min="0"
              value={cost}
              placeholder={props.cost}
              onChange={(e) => setcost(e.target.value)}
            />
          </label>
          <label>{inventoryText("inventory.Price")}:<input
              className="form-control"
              type="number"
              step="0.0001"
              min="0"
              value={price}
              placeholder={props.price}
              onChange={(e) => setprice(e.target.value)}
            />
          </label>
          {group === "yes" && (
            <label>
              Retail Price:
              <input
                className="form-control"
                type="number"
                step="0.01"
                min="0"
                value={retail}
                placeholder={props.retail}
                onChange={(e) => setretail(e.target.value)}
              />
            </label>
          )}
          {group === "yes" && (
            <label>{inventoryText("inventory.Active")}:<input
                className="form-check-input"
                type="checkbox"
                checked={isActive}
                onChange={(e) =>
                  setIsActive(e.target.checked)
                }
              />
            </label>
          )}
          <div className="fo">
            <button type="submit" className="btn btn-primary btn-md">{inventoryText("inventory.Edit")}</button>
          </div>
        </form>
      </div>
      {/* Popup Message */}
      {message && (
        <div
          className={`alert alert-${message.type} alert-dismissible fade show`}
          role="alert"
          style={{
            position: "fixed",
            bottom: "10px",
            margin: "10px",
            right: "10px",
            zIndex: "9999",
          }}
        >
          {message.text}
        </div>
      )}
    </div>
  );
}

export default EditProduct;
